<div style="display: none;">
  <h1>{{title}}</h1>
  <button (click) = "fetchTitle()">Click Me</button>
</div>

<router-outlet></router-outlet>